import { useState } from "react";
import { Link } from "react-router-dom";
import {useNavigate} from "react-router-dom";

function Header() {
    const token=localStorage.getItem ('token');
    const [open,setOpen] = useState(false);
    const navigate = useNavigate ();

    return (

        <header className="
            fixed
            top-0
            left-0
            w-full
            z-50
            bg-slate-950/80
            backdrop-blur-xl
            border-b
            border-slate-800
        ">


            <div className="
                max-w-7xl
                mx-auto
                px-5
                py-4
                flex
                items-center
                justify-between
            ">


                {/* Logo */}

                <Link to="/"

                    className="
                    text-2xl
                    font-black
                    text-cyan-400
                    hover:text-cyan-300
                    transition
                    "
                >

                    <span className="text-orange-500">
                      Mega Games
                    </span>

                </Link>




                {/* Desktop Menu */}

                <nav className="
                    hidden
                    md:flex
                    items-center
                    gap-8
                ">


                    <NavLink text="خانه" link="/" />

                    <NavLink text="محصولات" link="/PaymentResult" />

                    <NavLink text="درباره ما" link="/about" />

                    <NavLink text="تماس با ما" link="/contact" />


                </nav>





                {/* Login Desktop */}
                {
                  (token==undefined)?
                <div className="hidden md:block">


                    <Link

                    to="/PhoneNumber"

                    className="
                    bg-orange-500
                    hover:bg-orange-400
                    px-6
                    py-3
                    rounded-2xl
                    font-bold
                    transition
                    hover:scale-105
                    shadow-lg
                    shadow-orange-500/30
                    "

                    >

                    ورود

                    </Link>


                </div>
                 :
                 <div className="hidden md:block">


                     <Link

                     to="/Dashboard"

                     className="
                     bg-orange-500
                     hover:bg-orange-400
                     px-6
                     py-3
                     rounded-2xl
                     font-bold
                     transition
                     hover:scale-105
                     shadow-lg
                     shadow-orange-500/30
                     "

                     >

                     داشبورد

                     </Link>


                 </div>
               }




                {/* Mobile Button */}

                <button

                onClick={()=>setOpen(!open)}

                className="
                md:hidden
                text-cyan-400
                text-3xl
                "

                >

                ☰

                </button>


            </div>






            {/* Mobile Menu */}

            {

            open &&

            <div className="
                md:hidden
                px-5
                pb-6
                bg-slate-950
                border-t
                border-slate-800
            ">


                <div className="
                    flex
                    flex-col
                    gap-4
                    pt-5
                ">

                    <Link to="/">خانه</Link>

                    <Link to="/products">محصولات</Link>

                    <Link to="/About">درباره ما</Link>

                    <Link to="/contact">تماس با ما</Link>

                      {
                        (token==undefined)?
                        <button
                        onClick={()=>{navigate("/PhoneNumber")}}
                        className="
                        mt-12
                        bg-orange-500
                        px-12
                        py-4
                        rounded-2xl
                        text-lg
                        hover:scale-110
                        transition
                        shadow-xl
                        shadow-orange-500/40
                        ">

                        ورود به سامانه

                        </button>
                        :
                        <button
                        onClick={()=>{navigate("/Dashboard")}}
                        className="
                        mt-12
                        bg-orange-500
                        px-12
                        py-4
                        rounded-2xl
                        text-lg
                        hover:scale-110
                        transition
                        shadow-xl
                        shadow-orange-500/40
                        ">

                        داشبورد

                        </button>
                      }






                </div>


            </div>

            }


        </header>

    );

}





function NavLink({text,link}){


return (

<a

href={link}

className="
text-gray-300
hover:text-cyan-400
transition
relative
group
"


>

{text}


<span className="
absolute
bottom-0
left-0
w-0
h-0.5
bg-orange-500
group-hover:w-full
transition-all
duration-300
">

</span>


</a>

);


}



export default Header;
